import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default () => {
  const { t } = useI18n();
  const numberTransform = (value: any) => (isNaN(value) ? undefined : value);

  const schema = yup.object().shape({
    originalTime: yup.number().transform(numberTransform).optional().nullable(),
    time: yup
      .number()
      .transform(numberTransform)
      .min(1, t('errorMessages.genericRequired'))
      .required(t(`errorMessages.genericRequired`)),
    averagePrepTime: yup
      .number()
      .transform(numberTransform)
      .required(t(`errorMessages.genericRequired`))
      .min(1, t('errorMessages.genericRequired')),
    customers_per_slot: yup
      .number()
      .transform(numberTransform)
      .required(t(`errorMessages.genericRequired`))
      .min(1, t('errorMessages.genericRequired')),
  });

  return {
    schema,
  };
};
